import { database } from '@shared/database'

export class Info {
  // 各ニュース1つ
  constructor(news) {
    this.title = news.title
    this.text = news.text
    this.createdAt = news.createdAt
    this.updatedAt = news.updatedAt
    this.endedAt = news.endedAt
    this.images = news.images
    this.infoId = news.infoId
    this.sendType = news.sendType
    this.noticePlace = news.noticePlace
    this.onlyNativeApp = !!news.onlyNativeApp

    if (this.sendType === 'selectedUsers') {
      this.selectedUsers = news.selectedUsers
    }
  }
}

export class InfoList {
  #user = {}
  #list = []
  #validList = []
  #isBlpb = false

  // Stealthのお知らせを取得するかどうか
  stealth = false
  // MyPage用のお知らせを取得するかどうか
  myPage = false

  constructor(user) {
    this.#list = []
    this.#user = user
  }

  isBlpb() {
    return this.#isBlpb
  }

  // お知らせをDBから取得して情報を同期
  async fetch() {
    if (this.#user.type.includes('blackListPb')) this.#isBlpb = true

    let noticePlace = ['all']
    if (this.stealth) noticePlace.push('stealth')
    if (this.myPage) noticePlace.push('mypage')

    // お知らせを取得
    const infoForAll = (
      await database
        .infoCollection()
        .getInfoAlert(this.isBlpb() ? ['all', 'blpb'] : ['all'], noticePlace)
    ).map((rawinfo) => {
      return new Info(rawinfo)
    })
    const infoForSelectedUsers = (
      await database
        .infoCollection()
        .getInfoAlertWithSelectedUser(
          this.isBlpb() ? ['selectedUsers', 'blpb'] : ['selectedUsers'],
          noticePlace,
          this.#user.uid
        )
    ).map((rawinfo) => {
      return new Info(rawinfo)
    })
    // 配列を結合して日付降順でソート
    this.#list = [...infoForAll, ...infoForSelectedUsers].sort((a, b) => {
      return b.createdAt - a.createdAt
    })

    // 変な状態を除外
    if (!this.#user || !this.#list || !this.#list.length) {
      return
    }

    // 既読情報がない場合は作成
    if (this.#user && !this.#user.readInfo) {
      this.#user.readInfo = []
      await database.userCollection().update(this.#user.uid, {
        readInfo: []
      })
    }

    // 既読情報を追加
    this.#list.forEach((info) => {
      switch (info.sendType) {
        case 'selectedUsers':
          if (info.selectedUsers.includes(this.#user.uid)) {
            info.isRead = this.#user.readInfo.includes(info.infoId)
          }
          break
        case 'blpb':
          if (this.isBlpb()) {
            info.isRead = this.#user.readInfo.includes(info.infoId)
          }
          break
        case 'all':
          info.isRead = this.#user.readInfo.includes(info.infoId)
          break
      }
    })

    // 特定の条件で除外する
    this.#validList = this.#list.filter((info) => {
      // 有効期限が切れている場合
      if (typeof info.endedAt === 'object') {
        if (new Date().getTime() > info.endedAt.toDate().getTime()) return false
      }

      if (info.onlyNativeApp) {
        return false
      }

      return true
    })
  }

  // withStealthはfetchの前に呼ぶ必要がある
  withStealth() {
    this.stealth = true
    return this
  }

  // withMyPageはfetchの前に呼ぶ必要がある
  withMyPage() {
    this.myPage = true
    return this
  }

  // withAllはfetchの前に呼ぶ必要がある
  withAll() {
    this.myPage = true
    this.stealth = true
    return this
  }

  getList() {
    return this.#validList
  }

  getUnreadList() {
    return this.#validList.filter((info) => {
      // 既読の場合は除外
      return info.isRead === false
    })
  }

  // ステルス以外の未読のお知らせを取得(mypageとallのお知らせを取得)
  getUnreadListWithoutStealth() {
    return this.getUnreadList().filter((info) => {
      //console.log(info)
      return info.noticePlace !== 'stealth'
    })
  }

  getUnreadListWithoutStealthAndMypage() {
    return this.getUnreadListWithoutStealth().filter((info) => {
      return info.noticePlace !== 'mypage'
    })
  }

  // 既読情報から存在しないinfoを除外
  async cleanUpOldReadInfo() {
    if (!this.myPage || !this.stealth || !this.#list) {
      throw new Error(
        'cleanUpOldReadInfoはwithAll()とfetch()を呼んでから呼ぶ必要があります'
      )
    }

    if (this.#user.readInfo && this.#user.readInfo.length > 0) {
      let shouldDbUpdate = false
      this.#user.readInfo = this.#user.readInfo.filter((info) => {
        if (this.#list.find((l) => l.infoId === info)) return true
        shouldDbUpdate = true
        return false
      })

      if (shouldDbUpdate) {
        console.log('readInfo updated')
        await database.userCollection().update(this.#user.uid, {
          readInfo: this.#user.readInfo
        })
      }
    }
  }
}
